module.exports = __webpack_public_path__ + "static/media/backup-services.a03a0e51.svg";